import materialColors from 'vuetify/es5/util/colors';

export default {
  primary: materialColors.blueGrey.darken4,
  secondary: materialColors.green.base,
  tertiary: materialColors.blueGrey.darken3,
  box: materialColors.blueGrey.lighten5,
  accent: materialColors.blueGrey.lighten2,
  error: materialColors.red.base,
  warning: materialColors.red.base,
  info: materialColors.blue.base,
  callReceived: materialColors.blue.base,
  callAccepted: materialColors.green.base,
  callDeclined: materialColors.orange.base,
  callLost: materialColors.red.base,
  success: materialColors.green.base,
  progress: materialColors.blue.base,
  active: materialColors.blue.base,
  message_agent: materialColors.blueGrey.lighten4,
  message_user: materialColors.blueGrey.lighten5,
  message_default: materialColors.blueGrey.lighten5,
  'notification-info': materialColors.grey.darken4,
  'button-choice': materialColors.blue.darken2,
  'main-bar': materialColors.blueGrey.darken3,
  'job-list-content': materialColors.blueGrey.darken2,
  'job-active-content': materialColors.blueGrey.darken1,
};
